import types from './actionTypes'
import shortUUid from 'short-uuid'
import { getLoggedInUserId } from "../../store/auth/selectors"
import {
    getClusterlets,
    getProfileAssociates,
    getDelegateAssociates,
} from '../../store/constructs/clusterlets/selectors'
import { getClusterletConnections } from '../../store/constructs/clusterlet_connections/selectors'
import { getInstances } from '../../store/constructs/bootloaders/selectors'
import { getNestedTransactions, getAllTransactions, getTransaction } from '../../store/constructs/transactions/selectors'
import { getTransactionEvents, getAllEvents } from '../../store/constructs/events/selectors'
import { getSections } from '../../store/constructs/sections/selectors'
import { getFields } from '../../store/constructs/fields/selectors'
import { getNetworks } from '../../store/constructs/networks/selectors'
import { getViews } from '../../store/views/selectors'
import { getLuaEditorData } from '../../store/constructs/handlers/selectors';
import { getUtilityFunctions } from '../../store/constructs/utility_functions/selectors';
import { getMessages } from '../../store/constructs/messages/selectors'
import { getRoutingRules } from '../../store/constructs/routing_rules/selectors'
import { getUserTriggers } from '../../store/constructs/user_triggers/selectors'
import { constructIds, cloneClusterletTags } from '../../config/common'
import Requester from "../blueprint/svc";
import { getBlueprintDetails } from '../../store/global/selectors'
import { findundoRedoItem } from "../../services/builder/util";
import { getTemplateClusterlets } from '../../store/constructs/templated_clusterlet/selectors'
import { getTransactionsAssociatedWithClusterlet } from '../../store/constructs/transactions/selectors';


const fetch = new Requester();

/** General - add item to redo */
export const addRedo = payload => ({ type: 'ADD_REDO', payload })

/** General - add item to undo */
export const addUndo = payload => ({ type: 'ADD_UNDO', payload })

/** General - wrapper function */
const wrapWithMeta = (payload, getState) => {

    const userId = getLoggedInUserId(getState())
    const blueprintId = getBlueprintDetails(getState()).docid;

    return {

        ...payload,
        id: shortUUid.generate(),
        user: userId,
        blueprint: blueprintId,
        dependencies: {},
    }
}

const getOrder = (array, id) => {
    const orderofElement = array.find(a => a.id === id)
    return orderofElement.order;
}

/** Get construct id */
const getConstructID = type => {
    let construct = constructIds.find(c => c.type == type)
    return construct.id
}

/** Specific - dealwith clusterlets */
export const dealWithClusterlets = (item, action, associates) => async (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_CLUSTERLET' : 'ADD_CLUSTERLET'
    let redo = action == 'add' ? 'ADD_CLUSTERLET' : 'REMOVE_CLUSTERLET'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (item.type === 6 && action === 'add') {
        const { connections, instances, parentClusterlets } = getProfileAssociates({ item, state: getState() })
        payload.dependencies.connections = connections
        payload.dependencies.instances = instances
        payload.dependencies.parentClusterlets = parentClusterlets
    }


    if (item.type === 1 && action === 'add') {
        const { instances } = await getDelegateAssociates({ item, state: getState() })
        payload.dependencies.instances = instances
    }

    if ((item.type === 2 || item.type === 20) && action === 'add') {
        // console.log({item, associates})
        if (associates?.connections !== undefined) payload.dependencies.connections = associates.connections;
        if (associates?.delegates !== undefined) payload.dependencies.delegates = associates.delegates;
        if (associates?.instances !== undefined) payload.dependencies.instances = associates.instances;
        if (associates?.networks !== undefined) payload.dependencies.networks = associates.networks;
        if (associates?.sensors !== undefined) payload.dependencies.sensors = associates.sensors;
    }

    if (action == 'edit') {

        console.log('associates---->', associates)
        let clusterlets = getClusterlets(getState())
        let original = clusterlets.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_CLUSTERLET'
        payload.redo = 'REDO_EDIT_CLUSTERLET'
        payload.dependencies.edited = item
        payload.dependencies.original = original
        if (associates?.originalrrdefs !== undefined) payload.dependencies.originalrrdefs = associates?.originalrrdefs;
        if (associates?.editedrrdefs !== undefined) payload.dependencies.editedrrdefs = associates?.editedrrdefs;
        if (associates?.network) payload.dependencies.network = associates?.network;
    }


    // if edited element has a profile, the profile data has to be saved
    if (action === 'edit' && (item.type === 2 || item.type === 3)) {
        let clusterlets = getClusterlets(getState())
        const nodes = JSON.parse(JSON.stringify(clusterlets))

        const profileIds = item?.profile ? item.profile.map(item => item.id) : []
        const originalProfiles = await nodes.filter(clusterlet => {
            if (profileIds.includes(clusterlet.id)) {
                return JSON.parse(JSON.stringify(clusterlet))
            }
        })

        const profiles = originalProfiles.map(item => {
            return JSON.parse(JSON.stringify(item))
        })

        const editedProfiles = await profiles.map(item => {
            const profile = JSON.parse(JSON.stringify(item))
            profile.name = `${payload.item.name}_Profile`
            return profile
        })

        // console.log("profiles", {originalProfiles, editedProfiles})

        payload.dependencies.originalProfiles = originalProfiles
        payload.dependencies.editedProfiles = editedProfiles

    }

    if (action === 'edit' && item.clusterletChangedForProfile === true) {

        payload.dependencies.clusterletChangedForProfile = payload.item.clusterletChangedForProfile
        payload.dependencies.currentClusterletId = payload.item.currentClusterletId
        payload.dependencies.previousClusterletId = payload.item.previousClusterletId
        payload.dependencies.previousConnection = payload.item.previousConnection
        payload.dependencies.newConnection = payload.item.newConnection
        payload.item = payload.item.editedElement
        payload.dependencies.edited = item.editedElement
        payload.dependencies.original = item.original
    }

    if (action === 'clone') {
        payload.undo = 'REMOVE_CLUSTERLET'
        payload.redo = 'ADD_CLUSTERLET'
        payload.dependencies.original = item.clonedItem
        if (item.sections?.length) payload.dependencies.sections = item.sections
        if (item.fields?.length) payload.dependencies.sectionFields = item.fields
        if (item.instancesForClonedNode?.length > 0) payload.dependencies.instances = item.instancesForClonedNode
        if (item.profiles?.length) payload.dependencies.profiles = item.profiles
        if (item.connections?.length) payload.dependencies.connections = item.connections
        if (item.profileFields?.length) payload.dependencies.profileFields = item.profileFields
        if (item.profileSections?.length) payload.dependencies.profileSections = item.profileSections
        payload.item = item.clusterlet

    }

    if (action === 'delete') {

        const associatedTransactions = getTransactionsAssociatedWithClusterlet(item.transactionsBeforeEdit, { id: item?.item?.id });
        if (item.connections?.length) payload.dependencies.connections = item.connections;
        if (item.sections?.length) payload.dependencies.sections = item.sections;
        if (item.sectionFields?.length) payload.dependencies.sectionFields = item.sectionFields;
        if (item.rrdefs?.length) payload.dependencies.rrdefs = item.rrdefs;
        if (item.userTriggers?.length) payload.dependencies.userTriggers = item.userTriggers;
        if (item.instances?.length) payload.dependencies.instances = item.instances;
        if (item.profiles?.length) payload.dependencies.profiles = item.profiles;
        if (item.profileFields?.length) payload.dependencies.profileFields = item.profileFields;
        if (item.profileSections?.length) payload.dependencies.profileSections = item.profileSections;
        if (item.profileInstances?.length) payload.dependencies.profileInstances = item.profileInstances;
        if (item.undoRedoEventData?.length) payload.dependencies.events = item.undoRedoEventData;
        if (item.clusterletEdited) payload.dependencies.clusterletEdited = item.clusterletEdited;
        if (item.network) payload.dependencies.network = item.network;
        if (associatedTransactions.length) payload.dependencies.transactions = associatedTransactions;
        payload.item = item.item
    }



    await dispatch({ type: types.ADD_UNDO, payload: payload })
}

/** Specific - clusterlet connections to undo */
export const dealWithClusterletConnections = (item, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'DELETE_CONNECTION' : 'ADD_CONNECTION'
    let redo = action == 'add' ? 'ADD_CONNECTION' : 'DELETE_CONNECTION'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (action == 'add') {
        if (item.connectedTemplate.length) payload.dependencies.connectedTemplate = item.connectedTemplate;
        payload.item = item.item
    }

    if (action == 'delete') {
        if (item.connetedTemplate?.length) payload.dependencies.connectedTemplate = item.connetedTemplate;
        payload.item = item.item
    }

    dispatch({ type: types.ADD_UNDO, payload })

}

/** Specific - transactions */
export const dealWithTransactions = (item, action, associatedData, handlersToAdd = [], handlersToDelete = [], eventAssociatedData) => (dispatch, getState) => {

    let constructID = getConstructID('nested_transaction')

    let undo;
    let redo;

    if (item.type == constructID) {
        undo = action == 'add' ? 'REMOVE_NESTED_TRANSACTION' : 'ADD_NESTED_TRANSACTION'
        redo = action == 'add' ? 'ADD_NESTED_TRANSACTION' : 'REMOVE_NESTED_TRANSACTION'
    } else {
        undo = action == 'add' ? 'REMOVE_TRANSACTION' : 'ADD_TRANSACTION'
        redo = action == 'add' ? 'ADD_TRANSACTION' : 'REMOVE_TRANSACTION'
    }

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {
        const orgTransaction = getTransaction(getState()).find(transaction => transaction.id === item.id);

        payload.undo = "UNDO_EDIT_TRANSACTION";
        payload.redo = "REDO_EDIT_TRANSACTION";
        payload.dependencies.original = orgTransaction;

        payload.dependencies.events = associatedData;
        payload.dependencies.userTriggers = eventAssociatedData.associatedUTs;
        payload.dependencies.rrdefs = eventAssociatedData.associatedRRdef;
        payload.dependencies.eventHandlers = eventAssociatedData.associatedHandlers;
        payload.dependencies.nestedTransEvents = eventAssociatedData.nestedTransEvents;

        if (handlersToAdd.length > 0) payload.dependencies.handlersToRemove = handlersToAdd;
        if (handlersToDelete.length > 0) payload.dependencies.handlersToAdd = handlersToDelete;
    }
    else if (action == 'delete') {

        payload.dependencies.events = associatedData.events;
        payload.dependencies.eventHandlers = associatedData.eventHandlers;
        payload.dependencies.nestedTransactions = associatedData.nestedTransactions;
        payload.dependencies.invokedTransactions = associatedData.invokedTRansactions;
        payload.dependencies.userTriggers = associatedData.userTriggers;
        payload.dependencies.rrdefs = associatedData.rrdefs;
        payload.dependencies.templateHandlers = associatedData.templateHandlers;
    }

    dispatch({ type: types.ADD_UNDO, payload })
}

/** Specific - events */
export const dealWithEvents = (item, eventAssociatedData, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_EVENT' : 'ADD_EVENT'
    let redo = action == 'add' ? 'ADD_EVENT' : 'REMOVE_EVENT'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (action === 'add') {
        payload.dependencies.order = eventAssociatedData.order;
        payload.dependencies.parentId = eventAssociatedData.parentTransactionId;
        payload.dependencies.rrdefs = eventAssociatedData.rrdefs

    }
    else if (action === 'edit') {
        const orgEvent = getAllEvents(getState()).find(event => event.id === item.id)

        payload.undo = "UNDO_EDIT_EVENT";
        payload.redo = "REDO_EDIT_EVENT";
        payload.dependencies.original = orgEvent;

        if (eventAssociatedData.original !== undefined) payload.dependencies.original = eventAssociatedData.original;

        if (eventAssociatedData.associatedRRdefs !== undefined) payload.dependencies.associatedRRdefs = eventAssociatedData.associatedRRdefs;
        if (eventAssociatedData.associatedUTs !== undefined) payload.dependencies.associatedUTs = eventAssociatedData.associatedUTs;
        if (eventAssociatedData.associatedHandlers !== undefined) payload.dependencies.associatedHandlers = eventAssociatedData.associatedHandlers;

        let rrdefs = JSON.parse(JSON.stringify(getRoutingRules(getState())))
        let userTiggers = JSON.parse(JSON.stringify(getUserTriggers(getState())))

        if (eventAssociatedData.rrdefs) {
            const rrdefsToDelete = rrdefs.filter(item => eventAssociatedData.rrdefs.deleteIds.includes(item.id))
            const rrdefsEdited = eventAssociatedData.rrdefs.editObjs;
            const rrdefsEditedIds = eventAssociatedData.rrdefs.editObjs.map(item => item.id)
            const rrdefsOriginal = rrdefs.filter(item => rrdefsEditedIds.includes(item.id))

            payload.dependencies.rrdefsToDelete = rrdefsToDelete;
            payload.dependencies.rrdefsEdited = rrdefsEdited;
            payload.dependencies.rrdefsOriginal = rrdefsOriginal;
        }

        if (eventAssociatedData.userTriggers) {
            const utsToDelete = userTiggers.filter(item => eventAssociatedData.userTriggers.deleteIds.includes(item.id))
            const utsEdited = eventAssociatedData.userTriggers.editObjs;
            const utsEditedIds = eventAssociatedData.userTriggers.editObjs.map(item => item.id)
            const utsOriginal = userTiggers.filter(item => utsEditedIds.includes(item.id))

            payload.dependencies.utsToDelete = utsToDelete;
            payload.dependencies.utsEdited = utsEdited;
            payload.dependencies.utsOriginal = utsOriginal;
        }

    }
    else if (action === 'delete') {
        payload.dependencies.order = eventAssociatedData.order;
        payload.dependencies.parentId = eventAssociatedData.parentTransactionId;
        if (eventAssociatedData.associatedRRdef !== undefined) payload.dependencies.rrdefs = eventAssociatedData.associatedRRdef;
        if (eventAssociatedData.associatedHandlers !== undefined) payload.dependencies.handlers = eventAssociatedData.associatedHandlers;
        if (eventAssociatedData.associatedUTs !== undefined) payload.dependencies.uts = eventAssociatedData.associatedUTs;
    }

    dispatch({ type: types.ADD_UNDO, payload })
}

/** Specific - nested transaction */
export const dealWithNestedTransactions = (item, associatedData, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_NESTED_TRANSACTION' : 'ADD_NESTED_TRANSACTION'
    let redo = action == 'add' ? 'ADD_NESTED_TRANSACTION' : 'REMOVE_NESTED_TRANSACTION'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'add') {

        let parentTransactionId = "";
        let orderInParent = 0;

        const transactionList = getTransaction(getState());
        transactionList.forEach(transaction => {
            transaction.nestedTransactions.forEach(nested => {
                if (nested.id === item.id) {
                    parentTransactionId = transaction.id;
                    orderInParent = nested.order;
                }
            })
        })


        payload.dependencies.order = orderInParent;
        payload.dependencies.parentId = parentTransactionId;
    }
    else if (action == 'edit') {

        const orgNestedTransaction = getNestedTransactions(getState()).find(nested => nested.id === item.id)

        payload.undo = "UNDO_EDIT_NESTEDTRANSACTION";
        payload.redo = "REDO_EDIT_NESTEDTRANSACTION";
        payload.dependencies.original = orgNestedTransaction;
    }
    else if (action == 'delete') {
        payload.dependencies.order = associatedData.order;
        payload.dependencies.parentId = associatedData.parentId;
        payload.dependencies.events = associatedData.events;
    }


    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithInvokedTransaction = (item, parentId, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_INVOKEDTRANSACTION' : 'ADD_INVOKEDTRANSACTION'
    let redo = action == 'add' ? 'ADD_INVOKEDTRANSACTION' : 'REMOVE_INVOKEDTRANSACTION'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (action == 'add') {
        payload.dependencies.parentId = parentId
    }

    if (action === 'edit') {

        const transactionList = getTransaction(getState());
        const parentTransaction = transactionList.find(transaction => transaction.id === parentId)
        const originalInvoked = parentTransaction.invokedTransactions.find(invoked => invoked.id === item.id)
        const invokedTransaction = transactionList.find(transaction => transaction.id === item.id);

        payload.undo = "UNDO_EDIT_INVOKEDTRANSACTION";
        payload.redo = "REDO_EDIT_INVOKEDTRANSACTION";
        payload.dependencies.original = originalInvoked;
        payload.dependencies.parentId = parentId;
    }

    if (action === 'delete') {
        payload.dependencies.parentId = parentId
    }

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithInstances = (item, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_INSTANCE' : 'ADD_INSTANCE'
    let redo = action == 'add' ? 'ADD_INSTANCE' : 'REMOVE_INSTANCE'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let instances = getInstances(getState())
        let original = instances.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_INSTANCE'
        payload.redo = 'REDO_EDIT_INSTANCE'
        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action === 'clone') {

        payload.undo = 'REMOVE_INSTANCE'
        payload.redo = 'ADD_INSTANCE'
        payload.dependencies.original = item.clonedItem
        payload.item = item.instance

    }

    if (action === 'delete') {

        if (item.userTriggers?.length) payload.dependencies.userTriggers = item.userTriggers
        payload.item = item.item

    }

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithSections = (item, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_SECTION' : 'ADD_SECTION'
    let redo = action == 'add' ? 'ADD_SECTION' : 'REMOVE_SECTION'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let sections = getSections(getState())
        let original = sections.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_SECTION'
        payload.redo = 'REDO_EDIT_SECTION'
        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action === 'clone') {

        payload.undo = 'REMOVE_SECTION'
        payload.redo = 'ADD_SECTION'
        payload.dependencies.original = item.clonedItem
        payload.item = item.sections[0]
        if (item.fields?.length) payload.dependencies.fields = item.fields

    }

    if (action === "delete") {
        if (item.nodeAssociatedFields?.length) payload.dependencies.sectionFields = item.nodeAssociatedFields
        payload.item = item.item

    }

    if (action == 'reorder') {
        payload.undo = 'RESET_REORDER_SECTION'
        payload.redo = 'REORDER_SECTION'
    }

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithFields = (item, action, associates) => async (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_FIELD' : 'ADD_FIELD'
    let redo = action == 'add' ? 'ADD_FIELD' : 'REMOVE_FIELD'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action === 'add') {
        if (associates.nestedFields && associates.nestedFields.length > 0) payload.dependencies.fields = associates.nestedFields;
    }

    if (action == 'edit') {

        let fields = getFields(getState())
        let original = fields.find(c => c.id == item.id)


        payload.undo = 'UNDO_EDIT_FIELD'
        payload.redo = 'REDO_EDIT_FIELD'
        payload.dependencies.edited = item
        payload.dependencies.original = original

        if (associates?.addUndoDepnedency != undefined) payload.dependencies.addUndoDepnedency = associates?.addUndoDepnedency;
        if (associates?.deleteUndoDependency != undefined) payload.dependencies.deleteUndoDependency = associates?.deleteUndoDependency;
    }

    if (action === 'clone') {

        const fieldsArray = JSON.parse(JSON.stringify(payload.item.fields))
        const nestedFields = await fieldsArray.splice(1, 1)

        payload.undo = 'REMOVE_FIELD'
        payload.redo = 'ADD_FIELD'
        payload.dependencies.original = item.clonedItem
        /* fields data come as a single array of fields
         * so the first element of array is the newly added
         * remaning are the nested fields of the newly added field
        */
        payload.item = item.fields[0]
        if (nestedFields.length > 0) payload.dependencies.fields = nestedFields

    }

    if (action === "delete") {

        if (item.nodeAssociatedFields?.length) payload.dependencies.fields = item.nodeAssociatedFields
        payload.item = item.item

    }

    if (action == 'reorder') {
        payload.undo = 'RESET_REORDER_FIELDS'
        payload.redo = 'REORDER_FIELDS'
    }

    await dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithNetworks = (item, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_NETWORK' : 'ADD_NETWORK'
    let redo = action == 'add' ? 'ADD_NETWORK' : 'REMOVE_NETWORK'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let networks = getNetworks(getState())
        let original = networks.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_NETWORK'
        payload.redo = 'REDO_EDIT_NETWORK'
        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action === 'clone') {
        console.log("original", item)
        payload.undo = 'REMOVE_NETWORK'
        payload.redo = 'ADD_NETWORK'
        payload.dependencies.original = item.clonedItem
        payload.item = item.network

    }

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithMessages = (item, action) => async (dispatch, getState) => {
    // console.log("item in messages", item)

    let undo = action == 'add' ? 'REMOVE_MESSAGE' : 'ADD_MESSAGE'
    let redo = action == 'add' ? 'ADD_MESSAGE' : 'REMOVE_MESSAGE'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let messages = getMessages(getState())
        let original = messages.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_MESSAGE'
        payload.redo = 'REDO_EDIT_MESSAGE'
        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action === 'clone') {
        payload.undo = 'REMOVE_MESSAGE'
        payload.redo = 'ADD_MESSAGE'
        payload.dependencies.original = item.clonedItem
        payload.item = item.message
        if (item.fields?.length) payload.dependencies.fields = item.fields

    }

    if (action === "delete") {

        if (item.nodeAssociatedFields?.length) payload.dependencies.fields = item.nodeAssociatedFields
        payload.item = item.item

    }

    await dispatch({ type: types.ADD_UNDO, payload })

}


export const dealWithRrdefs = (item, action) => (dispatch, getState) => {
    let undo = action == 'add' ? 'REMOVE_RRDEF' : 'ADD_RRDEF'
    let redo = action == 'add' ? 'ADD_RRDEF' : 'REMOVE_RRDEF'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let rrdefs = getRoutingRules(getState())
        let original = rrdefs.find(c => c.id == item.id)

        payload.undo = 'UNDO_EDIT_RRDEF'
        payload.redo = 'REDO_EDIT_RRDEF'
        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action === 'clone') {

        payload.undo = 'REMOVE_RRDEF'
        payload.redo = 'ADD_RRDEF'
        payload.dependencies.original = item.clonedItem
        payload.item = item.rrdef

    }

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithUserTriggers = (item, action) => (dispatch, getState) => {
    console.log("item in ut", item)
    let undo = action == 'add' ? 'REMOVE_USER_TRIGGER' : 'ADD_USER_TRIGGER'
    let redo = action == 'add' ? 'ADD_USER_TRIGGER' : 'REMOVE_USER_TRIGGER'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        let userTiggers = getUserTriggers(getState())
        let original = userTiggers.find(c => c.id == item.item.id)


        payload.undo = 'UNDO_EDIT_USER_TRIGGER'
        payload.redo = 'REDO_EDIT_USER_TRIGGER'
        payload.dependencies.edited = item.item
        payload.dependencies.original = original

        payload.dependencies.originalFields = item.originalFields
        payload.dependencies.editedFields = item.editedFields


    }

    if (action === 'clone') {

        payload.undo = 'REMOVE_USER_TRIGGER'
        payload.redo = 'ADD_USER_TRIGGER'
        payload.dependencies.original = item.clonedItem
        payload.item = item.userTrigger
        if (item.fields?.length) payload.dependencies.fields = item.fields

    }

    if (action === "delete") {

        if (item.nodeAssociatedFields?.length) payload.dependencies.fields = item.nodeAssociatedFields
        payload.item = item.item

    }

    if (action == 'reorder') {
        payload.undo = 'RESET_REORDER_USERTRIGGER'
        payload.redo = 'REORDER_USERTRIGGER'
    }

    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithLuaHandlers = (item, action) => async (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_LUAHANDLER' : 'ADD_LUAHANDLER'
    let redo = action == 'add' ? 'ADD_LUAHANDLER' : 'REMOVE_LUAHANDLER'

    let payload = wrapWithMeta({
        item: item,
        undo,
        redo
    }, getState)

    let luaHandlers = getLuaEditorData(getState())
    let original = luaHandlers.find(c => c.id == payload.item.id)

    if (action === 'edit') {
        payload.undo = 'UNDO_EDIT_LUAHANDLER'
        payload.redo = 'REDO_EDIT_LUAHANDLER'
        payload.dependencies.edited = payload.item
        payload.dependencies.original = original
    }


    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithUtilityFunctions = (item, action) => async (dispatch, getState) => {
    let undo = action == 'add' ? 'REMOVE_UTILITY_FUNCTIONS' : 'ADD_UTILITY_FUNCTIONS'
    let redo = action == 'add' ? 'ADD_UTILITY_FUNCTIONS' : 'REMOVE_UTILITY_FUNCTIONS'

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    let originalUtilityFunctions = getUtilityFunctions(getState())

    if (action === 'edit') {
        payload.undo = 'UNDO_EDIT_UTILITY_FUNCTIONS'
        payload.redo = 'REDO_EDIT_UTILITY_FUNCTIONS'
        payload.dependencies.edited = item;
        payload.dependencies.original = originalUtilityFunctions.data;
    }

    dispatch({ type: types.ADD_UNDO, payload })
}

export const resetUndoRedo = () => {
    return async (dispatch, getState) => {
      dispatch({ type: types.RESET_UNDOREDO });
      return Promise.resolve();
    };
  };


export const updateUndo = (undo) => ({
    type: types.UPDATE_UNDO,
    payload: undo
})

export const updateRedo = (redo) => ({
    type: types.UPDATE_REDO,
    payload: redo
})

/** Read undo/redo data from the API on-demand */
export const readUndoRedo = (target) => async (dispatch, getState) => {
    try {

        const blueprintId = getBlueprintDetails(getState()).docid
        const slug = getBlueprintDetails(getState()).slug;
        const folderName = [slug, blueprintId].join("-");
        let res = await fetch.post(fetch.route.read, { folderName });

        if (target == 'undo') {
            updateUndo(res.undoRedo.undo);
        }
        else if (target == 'redo') {

            updateRedo(res.undoRedo.redo);
        }

    } catch (error) {
        console.log('Error while reading Undo/Redo')
    }
};

export const updatePosition = (payload) => async (dispatch, getState) => {
    // console.log(payload)

    dispatch({
        type: types.UPDATE_POSITION,
        payload
    })
}

export const dealWithViewUi = (item, action, associates) => async (dispatch, getState) => {

    // console.log({item, action, associates})

    let undo = action == 'add' ? 'REMOVE_VIEW_UI' : action == 'edit' ? 'UNDO_EDIT_VIEW_UI' : 'ADD_VIEW_UI';
    let redo = action == 'add' ? 'ADD_VIEW_UI' : action == 'edit' ? 'REDO_EDIT_VIEW_UI' : 'REMOVE_VIEW_UI';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (associates.parentID) payload.dependencies.parentID = associates.parentID
    if (associates.rootId) payload.dependencies.rootId = associates.rootId
    if (associates.original) payload.dependencies.original = associates.original



    const newPayload = JSON.parse(JSON.stringify(payload));

    if (action === 'edit') {
        newPayload.dependencies.edited = item;
        newPayload.dependencies.original = associates.original;

        // delete newPayload.item.children;
        // delete newPayload.dependencies.edited.children;
        // delete newPayload.dependencies.original.children;
    }

    dispatch({ type: types.ADD_UNDO, payload: newPayload })
}

export const popUndo = (payload) => async (dispatch, getState) => {
    dispatch({
        type: types.POP_UNDO,
        payload
    })
}

export const popRedo = (payload) => async (dispatch, getState) => {
    dispatch({
        type: types.POP_REDO,
        payload
    })

}

export const dealWithViewSection = (item, action, associates) => async (dispatch, getState) => {
    // console.log({ item, action, associates })

    let undo = action == 'add' ? 'REMOVE_VIEW_SECTION' : action == 'edit' ? 'UNDO_EDIT_VIEW_SECTION' : 'ADD_VIEW_SECTION';
    let redo = action == 'add' ? 'ADD_VIEW_SECTION' : action == 'edit' ? 'REDO_EDIT_VIEW_SECTION' : 'REMOVE_VIEW_SECTION';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action === 'add') {
        if (associates.parentID !== undefined) payload.dependencies.parentId = associates.parentID;
        payload.dependencies.rootId = associates.rootId
    }

    if (action === 'edit') {

        const itemOnly = JSON.parse(JSON.stringify(item));
        delete itemOnly.children;
        payload.item = itemOnly

        if (associates.parentID !== undefined) payload.dependencies.parentId = associates.parentID;
        if (associates.original !== undefined) {
            const originalItemOnly = JSON.parse(JSON.stringify(associates.original))
            delete originalItemOnly.children
            payload.dependencies.original = originalItemOnly;
        }
        payload.dependencies.rootId = associates.rootId

    }

    if (action === 'delete') {
        if (associates.parentID !== undefined) payload.dependencies.parentId = associates.parentID;
        payload.dependencies.rootId = associates.rootId
    }

    await dispatch({ type: types.ADD_UNDO, payload })

}


export const dealWithUiFields = (item, action, associates) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_UI_FIELD' : action == 'edit' ? 'UNDO_EDIT_UI_FIELD' : 'ADD_UI_FIELD';
    let redo = action == 'add' ? 'ADD_UI_FIELD' : action == 'edit' ? 'REDO_EDIT_UI_FIELD' : 'REMOVE_UI_FIELD';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (associates.parentID) payload.dependencies.parentID = associates.parentID
    if (associates.rootId) payload.dependencies.rootId = associates.rootId
    if (associates.original) payload.dependencies.original = associates.original



    const newPayload = JSON.parse(JSON.stringify(payload));

    if (action === 'edit') {
        newPayload.dependencies.edited = item;
        newPayload.dependencies.original = associates.original;

        // delete newPayload.item.children;
        // delete newPayload.dependencies.edited.children;
        // delete newPayload.dependencies.original.children;
    }

    dispatch({ type: types.ADD_UNDO, payload: newPayload })

}

export const dealWithTemplateClusterlet = (item, action) => (dispatch, getState) => {

    let undo = action == 'add' ? 'REMOVE_TEMPLATE_CLUSTERLET' : action == 'edit' ? 'UNDO_EDIT_TEMPLATE_CLUSTERLET' : 'ADD_TEMPLATE_CLUSTERLET';
    let redo = action == 'add' ? 'ADD_TEMPLATE_CLUSTERLET' : action == 'edit' ? 'REDO_EDIT_TEMPLATE_CLUSTERLET' : 'REMOVE_TEMPLATE_CLUSTERLET';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)


    if (action == 'edit') {

        let templates = getTemplateClusterlets(getState())
        let original = templates.find(c => c.id == item.id)

        payload.dependencies.edited = item
        payload.dependencies.original = original
    }

    if (action == 'delete') {
        if (item.connections?.length) payload.dependencies.connections = item.connections;
        payload.item = item.item
    }


    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithTemplateTransaction = (item, parentId, associatedData, action) => (dispatch, getState) => {
    console.log({ item, parentId, action, associatedData })

    let undo = action == 'add' ? 'REMOVE_TEMPLATE_TRANSACTION' : 'ADD_TEMPLATE_TRANSACTION';
    let redo = action == 'add' ? 'ADD_TEMPLATE_TRANSACTION' : 'REMOVE_TEMPLATE_TRANSACTION';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'add' || action === 'delete') {
        payload.dependencies.parentId = parentId
        payload.dependencies.handlers = associatedData
    }

    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithViewSchema = (item, action, associates) => (dispatch, getState) => {
    // console.log({ item, action, associates })

    let undo = action == 'add' ? 'REMOVE_VIEW' : action == 'edit' ? 'UNDO_EDIT_VIEW' : 'ADD_VIEW';
    let redo = action == 'add' ? 'ADD_VIEW' : action == 'edit' ? 'REDO_EDIT_VIEW' : 'REMOVE_VIEW';

    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    if (action == 'edit') {

        const editedObj = JSON.parse(JSON.stringify(item));
        const originalObj = JSON.parse(JSON.stringify(associates.original));

        delete editedObj.schema;
        delete originalObj.schema;

        payload.item = editedObj;

        payload.dependencies.edited = editedObj
        payload.dependencies.original = originalObj;

    }

    let originalViews = getViews(getState())


    if (action === 'reorder') {
        payload.undo = 'UNDO_REORDER_VIEWS'
        payload.redo = 'REDO__REORDER_VIEWS'
        payload.dependencies.edited = item;
        payload.dependencies.original = originalViews;
    }


    dispatch({ type: types.ADD_UNDO, payload })
}

export const dealWithReorderClusterlet = (item) => (dispatch, getState) => {
    let undo = 'UNDO_REORDER_CLUSTERLETS';
    let redo = 'REDO_REORDER_CLUSTERLETS';
    let payload = wrapWithMeta({
        item,
        undo,
        redo
    }, getState)

    dispatch({ type: types.ADD_UNDO, payload })

}

export const dealWithViewCopyPaste = (item) => (dispatch, getState) => {
    
    let undo = 'UNDO_VIEW_COPY_PASTE';
    let redo = 'REDO_VIEW_COPY_PASTE';
    
    let payload = wrapWithMeta({
        item: item.item,
        undo,
        redo
    }, getState)

    payload.dependencies.parentID = item.parentID;
    payload.dependencies.rootId = item.rootId;

    dispatch({ type: types.ADD_UNDO, payload })

}